"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBase64 = exports.parseJWT = exports.fromBase64 = void 0;

var _isDefined = require("./misc-checks/isDefined");

var _string = require("./type-checks/string");

var parseJWT = function parseJWT(token) {
  var jwtSegments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["header", "payload"];
  var returnObj = {};

  if ((0, _string.isStringOfLength)(token)) {
    var tokenSegments = token.split(".");
    tokenSegments.forEach(function (tokenSegment, i) {
      if ((0, _string.isStringOfLength)(jwtSegments[i])) {
        returnObj[jwtSegments[i]] = fromBase64(tokenSegment);
      }
    });
  }

  return returnObj;
};

exports.parseJWT = parseJWT;

var toBase64 = function toBase64(input) {
  var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var returnElem = false;

  if ((0, _isDefined.isDefined)(input)) {
    try {
      returnElem = scope.btoa(encodeURIComponent(JSON.stringify(input)));
    } catch (e) {
      console.warn("Could not encode string to Base64:", e);
    }
  }

  return returnElem;
};

exports.toBase64 = toBase64;

var fromBase64 = function fromBase64(input) {
  var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var returnElem = false;

  if ((0, _string.isString)(input)) {
    try {
      returnElem = JSON.parse(decodeURIComponent(scope.atob(input)));
    } catch (e) {
      console.warn("Could not decode string from Base64:", e);
    }
  }

  return returnElem;
};

exports.fromBase64 = fromBase64;